module.exports = {};



//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0